import SelectMenu from "../../controls/SelectMenu";
import Input from "../../controls/Input";
import ActionButton from "../../controls/ActionButton";
import { formatCurrency } from "../../../shared/utility";

function formatQty(value) {
  if (value == null || value === "") return "0";
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  return n.toLocaleString("en-US", { maximumFractionDigits: 3 });
}

function taxRateLabels(taxes = []) {
  if (!taxes.length) return null;
  return taxes
    .map((tax) => {
      const match = tax.label?.match(/^([^(]+)/);
      return match ? match[1].trim() : tax.label;
    })
    .join(", ");
}

export default function PurchaseOrderLineItemRow({
  row,
  assemblyItemOptions,
  onAssemblySelect,
  updateLineItem,
  onRemove,
}) {
  const assemblyValue =
    assemblyItemOptions.find((o) => o.value === row.assembly_item_id) || null;
  const uomLabel = row.unit_of_measure?.label ?? "—";
  const received = row.received_amount ?? 0;
  const ordered = row.ordered_quantity;
  const fulfillment =
    row.fulfillment_percent != null
      ? row.fulfillment_percent
      : Number(ordered) > 0
        ? Math.round((received / Number(ordered)) * 10000) / 100
        : 0;
  const taxLabels = taxRateLabels(row.taxes);

  return (
    <tr className="border-b border-[#E2E8F0]/70 align-top">
      <td className="min-w-[200px] px-3 py-3">
        <SelectMenu
          name={`item-${row.temp_id}`}
          options={assemblyItemOptions}
          value={assemblyValue}
          handleInputChange={(e) =>
            onAssemblySelect(row.temp_id, e.target.value)
          }
          placeholder="Select item…"
          menuPortalTarget={document.body}
        />
      </td>
      <td className="w-24 px-3 py-3">
        <Input
          name={`qty-${row.temp_id}`}
          type="number"
          min="0"
          step="any"
          value={row.ordered_quantity}
          onChange={(e) =>
            updateLineItem(row.temp_id, { ordered_quantity: e.target.value })
          }
        />
      </td>
      <td className="w-20 px-3 py-3 text-right text-sm tabular-nums text-[#64748B]">
        {formatQty(received)}
      </td>
      <td className="w-24 px-3 py-3 text-right">
        <div className="text-sm font-medium tabular-nums text-[#0F172A]">
          {fulfillment}%
        </div>
        <div className="text-xs tabular-nums text-[#64748B]">
          {formatQty(received)} / {formatQty(ordered)}
        </div>
      </td>
      <td className="w-28 px-3 py-3 text-center align-middle text-sm font-medium text-[#64748B]">
        {uomLabel}
      </td>
      <td className="w-28 px-3 py-3">
        <Input
          name={`cost-${row.temp_id}`}
          type="number"
          min="0"
          step="any"
          value={row.unit_cost}
          onChange={(e) =>
            updateLineItem(row.temp_id, { unit_cost: e.target.value })
          }
        />
      </td>
      <td className="whitespace-nowrap px-3 py-3 text-right text-sm font-medium tabular-nums text-[#0F172A]">
        {row.subtotal != null ? formatCurrency(row.subtotal) : "—"}
      </td>
      <td className="min-w-[100px] px-3 py-3 text-right">
        <div className="text-sm font-medium tabular-nums text-[#0F172A]">
          {row.tax_amount != null ? formatCurrency(row.tax_amount) : "—"}
        </div>
        {taxLabels ? (
          <div className="mt-0.5 text-xs text-[#64748B]">{taxLabels}</div>
        ) : null}
      </td>
      <td className="whitespace-nowrap px-3 py-3 text-right text-sm font-medium tabular-nums text-[#0F172A]">
        {row.line_total != null ? formatCurrency(row.line_total) : "—"}
      </td>
      <td className="whitespace-nowrap px-3 py-3 text-right">
        <ActionButton
          color="red"
          className="min-w-0 px-3"
          disabled={row.line_locked}
          onClick={() => onRemove(row.temp_id)}
        >
          Delete
        </ActionButton>
      </td>
    </tr>
  );
}
